import { ReactNode } from 'react'
import { ChevronLeft } from 'lucide-react'
import { cn } from '../../lib/utils'

export interface PageBrowProps {
  left: ReactNode
  right?: ReactNode
  onBack?: () => void
  backLabel?: string
  className?: string
}

export function PageBrow({ left, right, onBack, backLabel = 'Back', className }: PageBrowProps) {
  return (
    <div className={cn('flex h-14 shrink-0 items-center gap-3 border-b border-border bg-card px-6', className)}>
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          title={backLabel}
          aria-label={backLabel}
          className="-ml-2 mr-0.5 shrink-0 rounded-lg p-1.5 text-muted-foreground transition hover:bg-accent/60 hover:text-foreground"
        >
          <ChevronLeft size={18} />
        </button>
      )}
      <div className="min-w-0 flex-1">{left}</div>
      {right && <div className="shrink-0">{right}</div>}
    </div>
  )
}
